import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

const ERRORS = `errors { path, message }`;

const SALE_FIELDS = `
  fragment SaleFields on Sale {
    id
    name
    saleOn
    preBidOpenAt
    startAt
    endAt
    status
    recurringSale { id, name }
  }
`;

export const SALE = gql`
  ${SALE_FIELDS}
  query SALE($id: ID!) {
    sale(id: $id) {
      ...SaleFields
    }
  }
`;

export const SALES_WITH_COUNT = gql`
  ${SALE_FIELDS}
  query (
    ${WITH_COUNT_VARIABLES}
  ) {
    salesWithCount(
      ${WITH_COUNT_ARGUMENTS}
    ) {
      entries {
        ...SaleFields
        saleAssets { id }
      }
      count
    }
  }
`;

export const PAST_SALES = gql`
  ${SALE_FIELDS}
  query PastSales {
    pastSales {
      ...SaleFields
    }
  }
`;
